import './index.scss';
import '../../common/Joyride/styles.scss';
import React, { PropTypes } from 'react';
import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import ManagePageLayout from '../../common/PageLayout/Manage';
import CloneCard from '../../common/CloneCard';
import * as types from '../../../js/actions/actionTypes';
import operationTypes from '../../../js/operationTypes';
import { convertToByteUnitLabel, isUndefinedNullOrEmpty, formatDate } from '../../../js/utils';
import { imageStatuses } from '../../../js/statuses';
import { filterAndSortClones } from '../../../js/cloneFilter';
import { changeToManageMode } from '../../../js/actions/appModeActionCreators';
import { deleteImage } from '../../../js/actions/manageModeActionCreators';
import { hasValidLicence } from '../../../js/projections/licence';
import ImageStatus from '../ImageStatus';
import NoClones from '../NoClones';
import DeleteIcon from '../../../icons/clone-icons_delete.svg';
import ImageDeleteConfirmation from '../ImageDeleteConfirmation';
import { setTourEnabled } from '../../../js/actions/tourActionCreators';
import Joyride from 'react-joyride';
import { JoyrideStepStyle, JoyrideFinishStepStyle } from '../../common/Joyride/steps';
import DisableableLink from '../../common/DisableableLink';


const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

const steps = [{
    title: 'Create new clone',
    text: 'Now you have created an image you can create clones from it. The clone will always take seconds to create and use only MBs of disk space.<br><br>Clones can be connected to and edited with any program and changes are saved to a local differencing disk. The Image is immutable and cannot be edited or changed.',
    selector: '.button-primary',
    position: 'bottom',
    type: 'hover',
    isFixed: true,
    style: JoyrideStepStyle
}];

const cloneSteps = [{
    title: 'Clone created',
    text: 'Your clone has now been created!<br><br>Clones reference the image to look and work like full database copies.', // supports html tags
    selector: '.clone',
    position: 'right',
    type: 'hover',
    isFixed: true,
    style: JoyrideStepStyle
}, {
    title: 'Image size',
    text: 'This is the size of the image we just created. It is the full sized copy of the database at a point in time. Clones reference the data held in this image.', // supports html tags
    selector: '.imageSize',
    position: 'right',
    type: 'hover',
    isFixed: true,
    style: JoyrideStepStyle
}, {
    title: 'Clone size',
    text: 'This is the size of the new clone, notice the difference in size between this and the image.<br><br>Clones will appear as a normal database to SQL Server and report the full size including the image. You can create multiple clones per image and they are independent of each other. Changes to each clone are stored in a local differencing disk.', 
    selector: '.cloneSize',
    position: 'right',
    type: 'hover',
    isFixed: true,
    style: JoyrideStepStyle
}, {
    title: 'Deleting Images and Clones',
    text: 'Clones and images can also be deleted if you no longer need them. All clones must be deleted before an image can be deleted.', // supports html tags
    selector: '.delete-icon-tour',
    position: 'right',
    type: 'hover',
    isFixed: true,
    style: JoyrideStepStyle
}, {
    title: 'Ready to clone your own SQL Server databases?',
    text: 'Start by downloading our 14-day full functional free trial of SQL Clone now!<div class="text--center spaced-top"><a href="http://www.red-gate.com/products/dba/sql-clone/#contact" target="_blank" class="">Contact Sales</a> <a href="http://www.red-gate.com/products/dba/sql-clone/" target="_blank" class="button button--primary spaced-left--tight">Download free trial</a></div>', // supports html tags
    selector: '.imageHeader',
    position: 'bottom',
    type: 'hover',
    isFixed: true,
    style: JoyrideFinishStepStyle
}];

const ImageDetailPage = React.createClass({
    propTypes: {
        deleteImage: PropTypes.func.isRequired
    },
    tourCallback(value) {
        if (value && value.type === 'finished' && value.isTourSkipped && this.props.location.query.newImage) {
            ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'skippedImageCreated',
                    eventLabel: 'Tour skipped on image created'
                });
            this.props.setTourEnabled('dashboard', false);
        }
        if (value && value.type === 'finished' && !this.props.location.query.newImage && !value.isTourSkipped){
            ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'tourCompleted',
                    eventLabel: 'Tour completed on last step'
                });
            this.props.setTourEnabled('dashboard', false);
        }
        if (value && value.type === 'finished' && this.props.location.query.newImage && !value.isTourSkipped) {
            ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'finishedImageCreated',
                    eventLabel: 'End of image created tour'
                });
            browserHistory.push('/clones/create/source?imageId=' + this.props.image.id);
        }
        if (value && value.type === 'finished' && !this.props.location.query.newImage && value.isTourSkipped){
            ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'skippedCloneCreated',
                    eventLabel: 'Tour skipped on clone created'
                });
            this.props.setTourEnabled('dashboard', false);
        }
    },
    getInitialState: function () {
        return {
            showDeleteConfirmation: false
        };
    },
    componentDidMount() {
        this.props.alignMode();
    },
    componentWillReceiveProps: function (nextProps) {
        const { isImageDeletionCompleted } = nextProps;
        if (isImageDeletionCompleted) {
            browserHistory.push('/dashboard');
        }
    },
    requestImageDeletion: function (e) {
        this.setState({ showDeleteConfirmation: true });
        e.preventDefault();
    },
    onCancelDeletion: function (e) {
        this.setState({ showDeleteConfirmation: false });
        e.preventDefault();
    },
    onConfirmDeletion: function (e) {
        this.setState({ showDeleteConfirmation: false });
        this.props.deleteImage(this.props.params.imageId);
        e.preventDefault();
    },
    render: function () {
        const { image, imageDestinationLocation, serverName, databaseName, clones, imageCreationProgress, operation, canCreate, isNewImage } = this.props;
        const { showDeleteConfirmation } = this.state;
        const hasClones = clones.length > 0;
        const operationInProgress = operation && operation.isInProgress();
        const isCreated = image && image.status.state === imageStatuses.created && !operationInProgress;

        return <ManagePageLayout>
            {isCreated && <Joyride ref="joyride" run={this.props.tourEnabled} autoStart={true} showSkipButton={true} showStepsProgress={false} type="continuous" steps={hasClones ? cloneSteps : steps} debug={true} callback={this.tourCallback} locale={hasClones ? { last: 'Finish', next: 'Next', skip: 'Skip', back: 'Back' } : { last: 'Create Clone', next: 'Next', skip: 'Skip', back: 'Back' }} />}
            <div className="dashboard pure-g">
                <div className="pure-u-1-1">
                    <h1 className="imageHeader">Images and Clones</h1>
                </div>
                <Modal isOpen={showDeleteConfirmation} contentLabel="" style={modalStyles}>
                    <ImageDeleteConfirmation clones={clones} onConfirmDeletion={this.onConfirmDeletion} onCancelDeletion={this.onCancelDeletion} />
                </Modal>
                
                {!isUndefinedNullOrEmpty(image) && <div>
                    <div className="image-detail pure-u-1-1">
                        <div className="pure-u-2-3">
                            <h2 className="imageName">{image && image.name}</h2>
                            {isCreated && <p className="imageSize">{convertToByteUnitLabel(image.status.sizeInBytes)}</p>}
                            <p>Created by {image.createdBy}{image.createdDate && ` on ${formatDate(image.createdDate)}`}</p>
                        </div>
                        <div className="pure-u-1-3">
                            <div className="image-actions">
                                {isCreated &&
                                    <DisableableLink className="button-primary button--ghost" to={'/clones/create/source?imageId=' + image.id} disabled={!canCreate}>Clone</DisableableLink>}
                                     
                                {!operationInProgress &&
                                    <button onClick={this.requestImageDeletion} className="button--flat-secondary">
                                    Delete Image
                                    <img src={DeleteIcon} className="deleteIcon" data-content="Delete image" />
                                </button>}
                            </div>
                        </div>
                    </div>

                    <div className="pure-u-1-1 imageOrigin">
                        <div className="pure-u-1-1">
                            <ul className="pure-menu-horizontal">
                                <li className="serverName pure-menu-item">{serverName}</li>
                                <li className="databaseName pure-menu-item">{databaseName}</li>
                                <li className="imageLocation pure-menu-item">{imageDestinationLocation && imageDestinationLocation.uncPath}</li>
                            </ul>
                        </div>
                    </div>

                    {hasClones && <div className="pure-u-1-1">
                        <div className="pure-u-1-1">
                            <h3 className="cloneName">Clones ({clones.length})</h3>
                        </div>

                        <div className="clone-container pure-u-1-1">
                            <div className="clone-row pure-u-1-1">
                                {clones.map((c) => <div className="clone-box pure-u-1-4" key={c.id}>
                                    <CloneCard clone={c} />
                                </div>)}
                            </div>
                        </div>
                    </div>}

                    {!hasClones && <ImageStatus operation={operation} imageCreationProgress={imageCreationProgress} />}

                    {(!hasClones && isCreated) && <NoClones image={image} />}

                </div>}

                {isUndefinedNullOrEmpty(image) && <div>Loading image data..</div>}
            </div>
        </ManagePageLayout>;
    }
});

const mapStateToProps = (state, ownProps) => {
    const imageId = ownProps.params.imageId;
    const image = state.images.value.get(imageId);
    const clones = filterAndSortClones(Array.from(state.clones.value.values()).filter(c => c.parentImageId === imageId));
    const imageDestinationLocation = state.imageDestinationLocations.value.get(image && image.imageLocationId);
    const sqlServerInstance = state.sqlServerInstances.value.get(image && image.sourceLocationId);
    const serverName = sqlServerInstance && (sqlServerInstance.server + '\\' + sqlServerInstance.instance);
    const isNewImage = ownProps.location.query.newImage;
    let databaseName;

    if (!isUndefinedNullOrEmpty(image) && !isUndefinedNullOrEmpty(image.sourceLocationResourceNames) && image.sourceLocationResourceNames.length > 0) {
        databaseName = image && image.sourceLocationResourceNames[0];
    }

    const operation = !isUndefinedNullOrEmpty(image) && !isUndefinedNullOrEmpty(image.latestOperationId) ?
        state.operations.value.get(image.latestOperationId) :
        null;

    const imageCreationProgress = !isUndefinedNullOrEmpty(operation) && operation.type === operationTypes.createImage && operation.isInProgress() ?
        state.operationProgress.value.get(operation.operationId) :
        null;

    const isImageDeletionCompleted = operation && operation.type === operationTypes.dropImage && operation.isSuccessful();

    return {
        image: image,
        operation: operation,
        imageCreationProgress: imageCreationProgress,
        imageDestinationLocation: imageDestinationLocation,
        serverName: serverName,
        databaseName: databaseName,
        clones: clones,
        isImageDeletionCompleted: isImageDeletionCompleted,
        tourEnabled: state.tour.dashboard,
        isNewImage: isNewImage,
        canCreate: hasValidLicence(state)

    };
};

const mapDispatchToProps = (dispatch) => ({
    deleteImage: (imageId) => {
        dispatch(deleteImage(imageId));
    },
    alignMode: () => {
        dispatch(changeToManageMode());
    },
    setTourEnabled: (tour, enabled) => {
            dispatch(setTourEnabled(tour, enabled));
        }
});

export default connect(mapStateToProps, mapDispatchToProps)(ImageDetailPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/ImageDetailPage/index.jsx